import { Box, ButtonBase, Typography } from '@mui/material';
import React, { MouseEventHandler } from 'react';
import headerAdHocSmall from '../../assets/header-adhoc-small.svg';
import headerNeutralSmall from '../../assets/header-neutral-small.svg';
import ExerciseType from '../../exercise-type/ExerciseType';
import { ExerciseType as IExerciseType, SimulatorType } from '../../types';
import { getBgColor, getKSim } from '../../utils/ksim';

export interface TypeCardProps {
  adHoc?: boolean;
  exerciseType: IExerciseType;
  onClick: MouseEventHandler<HTMLButtonElement>;
  selected?: boolean;
  simulatorType: SimulatorType;
}

const TypeCard = ({ adHoc, exerciseType, onClick, selected = false, simulatorType }: TypeCardProps) => (
  <ButtonBase
    onClick={onClick}
    sx={theme => ({
      alignItems: 'center',
      backgroundColor: getBgColor(undefined, adHoc),
      backgroundImage: {
        xs: `url(${adHoc ? headerAdHocSmall : headerNeutralSmall})`,
      },
      backgroundPosition: 'center right -130px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      outline: selected ? `2px solid ${theme.palette.primary.main}` : null,
      borderRadius: '8px !important',
      display: 'flex',
      height: { xs: 129, sm: 153 },
      justifyContent: 'space-between',
      p: 3,
      textAlign: 'inherit',
      width: '100%',
    })}
  >
    <div>
      <ExerciseType type={exerciseType} />
      <Typography sx={{ maxWidth: 240 }}>
        {exerciseType === IExerciseType.SelfStudy
          ? adHoc
            ? 'Run a standalone simulation'
            : 'Students run simulations independently'
          : 'Run simulations with a group'}
      </Typography>
    </div>
    <Box
      component="img"
      src={getKSim(exerciseType, simulatorType)}
      height={{ xs: 75, sm: simulatorType === SimulatorType.Site ? 80 : 86 }}
      alt="K-Sim"
    />
  </ButtonBase>
);

export default TypeCard;
